<template>
	<TComboboxButton
		ref="TComboboxButton"
		icon="caret-down"
		:searchValue="searchValue"
		:items="sortedFilteredItems"
		v-bind="$attrs"
		@button:click="onButtonClick"
		@blur="onBlur"
		v-on="$listeners"
	>
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
	</TComboboxButton>
</template>

<script>
import TComboboxButton from './TComboboxButton';

export default {
	name: 'TCombobox',
	components: { TComboboxButton },
	props: {
		searchValue: {
			type: String,
			required: true
		},
		items: {
			type: Array,
			default: () => [],
		},
		sortFunction: {
			type: Function,
			required: false,
		},
		filterFunction: {
			type: Function,
			required: false,
		},
	},

	data() {
		return {
			useRawItems: false,
		};
	},

	computed: {
		sortedFilteredItems() {
			if (this.useRawItems) {
				return this.sortFunction
					? Array.from(this.items).sort(this.sortFunction)
					: this.items;
			}
			let filteredItems = this.filterFunction && this.searchValue.length
				? this.items.filter(this.filterFunction)
				: Array.from(this.items);
			return this.sortFunction ? filteredItems.sort(this.sortFunction) : filteredItems;
		},
	},

	watch: {
		searchValue() {
			this.useRawItems = false;
		},
	},

	methods: {
		onButtonClick() {
			this.useRawItems = true;
			this.$refs.TComboboxButton.focus();
		},
		onBlur(event) {
			this.useRawItems = false;
			this.$emit('blur', event);
		},
	}
};
</script>
